import { MemberDataTransferObject } from '@reward-platform/ancillaries-schemas/members'
import { nextApiClient } from './clients/nextApiClient'

export async function getMe(): Promise<MemberDataTransferObject> {
  const { data } = await nextApiClient.get<MemberDataTransferObject>(`/user/membership`)
  return data
}
